module.exports = __webpack_public_path__ + "img/arrow-down-green.47b25e44.svg";